import {
  AnnotationIcon,
  BriefcaseIcon,
  CogIcon,
  HomeIcon,
  LogoutIcon,
  OfficeBuildingIcon,
  SupportIcon,
  UsersIcon,
  ViewGridIcon,
} from '@heroicons/react/outline';
import { List } from 'immutable';
import { useCan } from '../hooks/use-can';
import { routesConfig } from './routes.config';

const sidebarConfig = [
  { name: 'home', href: routesConfig.DASHBOARD, icon: HomeIcon, current: false, exact: true },
  { name: 'settings', href: routesConfig.SETTINGS.USER_EDIT, icon: CogIcon, current: false },
  { name: 'feedback', href: routesConfig.FEEDBACK, icon: AnnotationIcon, current: false },
];

export const useSideBarConfig = () => {
  const { canManageUsers, isMaster, hasServiceCallAccess } = useCan();

  let list = List(sidebarConfig);

  if (isMaster) {
    list = list.push({
      name: 'partnerSettings',
      href: routesConfig.SETTINGS.PARTNER_EDIT,
      icon: BriefcaseIcon,
      current: false,
    });
  }

  if (canManageUsers) {
    list = list.push({
      name: 'team',
      href: routesConfig.SETTINGS.TEAM.INDEX,
      icon: UsersIcon,
      current: false,
    });
  }

  if (hasServiceCallAccess) {
    list = List([
      {
        name: 'serviceCallDashboard',
        href: routesConfig.SERVICE_CALL.DASHBOARD,
        icon: ViewGridIcon,
        current: false,
        group: 'serviceCall' as const,
      },
      {
        name: 'serviceCallCustomers',
        href: routesConfig.SERVICE_CALL.CUSTOMERS,
        icon: OfficeBuildingIcon,
        current: false,
        group: 'serviceCall' as const,
      },
    ]).concat(list);
  } else if (canManageUsers) {
    list = list.push({
      name: 'serviceCallApply',
      href: routesConfig.SERVICE_CALL.APPLY,
      icon: SupportIcon,
      current: false,
    });
  }

  list = list.push({
    name: 'logOut',
    href: routesConfig.AUTH.LOGOUT,
    icon: LogoutIcon,
    current: false,
  });

  return list.toArray();
};
